import { useRef } from "react";

/**
 * The value from the last render in which the dialog was open. A caller often clears what
 * a dialog shows in the same render that closes it (the selected item becomes null); this
 * keeps the old content on screen while the dialog animates out, instead of an empty or
 * half-reset dialog shrinking away.
 */
export const useLastWhileVisible = <T,>(visible: boolean, value: T): T => {
  const last = useRef(value);
  if (visible) {
    last.current = value;
  }
  return visible ? value : last.current;
};
